<!--USER DASHBOARD CERTIFICATIONS-->
<ng-container *ngIf="certificates">
  <section class="dashboard-certifications">
    <!--CERTIFICATIONS HEADING-->
    <h3 class="margin-left-large padding-top-large margin-bottom-large">Your Certifications</h3>
    <!--LOADING-->
    <ng-template [ngIf]="isLoading">
      <app-loading-spinner></app-loading-spinner>
    </ng-template>
    <!--END LOADING-->
    <!--END CERTIFICATIONS HEADING-->
    <div class="certifications-wrapper">
      <a
        href="{{ cert?.url }}"
        target="_blank"
        rel="noopener noreferrer nofollow"
        *ngFor="let cert of certificates; let i = index; trackBy: trackByCertificationTitle"
        class="gen-primary-link certificate margin-bottom-small">
        <!--BADGE ICON IF AVAILABLE-->
        <img
          alt="Certification: {{ cert?.title }}"
          title="Certification: {{ cert?.title }}"
          class="badge"
          src="{{ cert.image }}" />
        <!--END BADGE ICON IF AVAILABLE-->

        <!--CERTIFICATE INFO-->
        <span>
          {{ cert?.title }}<br />
          {{ cert?.level }}<br />
          <span *ngIf="cert?.expires" class="date">exp. {{ cert?.expires }}</span>
          <span *ngIf="!cert?.expires" class="date">No Expiration</span>
        </span>
        <!--END CERTIFICATE INFO-->
      </a>

      <!--NO BADGES FOUND MESSAGE-->
      <ng-container *ngIf="certificates.length === 0 && !isLoading">
        <p class="margin-left-large margin-top-large">No badges were found for your account.</p>
      </ng-container>
      <!--END NO BADGES FOUND MESSAGE-->
    </div>
  </section>
</ng-container>
<!--END USER DASHBOARD CERTIFICATIONS-->
